import type { FormState, RegisterReference } from '@/shared/types/users.types';
import type { C } from '@/utils/colorHelpers';

export function StepVehicle({
    form,
    set,
    toggleSpec,
    reference,
    c,
}: {
    form: FormState;
    set: <K extends keyof FormState>(k: K, v: FormState[K]) => void;
    toggleSpec: (id: number) => void;
    reference: RegisterReference;
    c: C;
}) {
    const inp = `w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 ${c.ring} focus:border-transparent`;

    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Véhicule et capacités</h2>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Type de véhicule *</label>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    {reference.vehicle_types.map(v => (
                        <button
                            key={v.id}
                            type="button"
                            onClick={() => set('vehicleTypeId', String(v.id))}
                            className={`p-3 border-2 rounded-lg text-sm font-medium transition-all ${
                                form.vehicleTypeId === String(v.id)
                                    ? `${c.border} ${c.light}`
                                    : 'border-gray-200 hover:border-gray-300'
                            }`}
                        >
                            {v.name}
                        </button>
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Poids max (kg) *</label>
                    <input
                        type="number"
                        value={form.capacityWeightKg}
                        placeholder="ex : 100"
                        className={inp}
                        onChange={e => set('capacityWeightKg', e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Volume max (m³) *</label>
                    <input
                        type="number"
                        value={form.capacityVolumeM3}
                        placeholder="ex : 20"
                        className={inp}
                        onChange={e => set('capacityVolumeM3', e.target.value)}
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Spécialisations *</label>
                <div className="grid grid-cols-2 gap-2">
                    {reference.specializations.map(s => (
                        <label
                            key={s.id}
                            className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer p-2 border rounded-lg hover:bg-gray-50"
                        >
                            <input
                                type="checkbox"
                                checked={form.specializationIds.includes(s.id)}
                                onChange={() => toggleSpec(s.id)}
                                className="rounded border-gray-300"
                            />
                            {s.name}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}
